<template>
    <div class="footer">
    <h1 class="titulo" style="padding-top:150px; padding-left: 20px;padding-right:20px">"Uno aprende haciendo las
        cosas;<br> porque aunque piense 
        que sabe, no tiene la certeza 
        hasta que lo intenta"</h1>
        <p>Sófocles, Siglo 5 A.C.</p>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'

  export default {
    
    name: 'app',

    data () {
      return {
        errorMessage:"",
        login:{
          usuario:"",
          password:""
          }
      }
    },

    computed:{
    ...mapGetters(['pathAPI','userLogged']),

    },

    methods:{
     
    },

    computed:{

    }
        ,
    components:{

    },

    mounted: function(){

    },


  }
</script>

<style>
.footer{
    color: white; 
    text-align: center ;
    background-image: url('/public/images/site/ark-background.svg');
    background-size:cover; 
    height: 600px;
}
</style>


// WEBPACK FOOTER //
// src/components/startPage/Footer.vue